import * as types from '../../mutation-types';


let overlayId = 0;

function getOverlayId() {
    return `overlay-${ overlayId++ }`;
}

export function registerOverlay({ commit }, { component, ...args }) {
    const id = getOverlayId();
    commit(types.REGISTER_OVERLAY, { id, component, args });
    return id;
}

export function unregisterOverlay({ commit }, { id }) {
    commit(types.UNREGISTER_OVERLAY, { id });
}

export function openOverlay({ commit }, { id, trackingId }) {
    commit(types.OPEN_OVERLAY, { id, trackingId });
}

export function closeOverlay({ commit }, { id }) {
    commit(types.CLOSE_OVERLAY, { id });
}
